<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-app-bar flat>
          <v-icon>directions</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;ABM de Políticas Comerciales</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)">
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-flex right>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar por Nombre"
                    single-line
                    hide-details></v-text-field>
                </v-flex>

                <v-data-table
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :options.sync="options"
                  v-model="selectedRow"
                  :footer-props="{
                    itemsPerPageOptions: options.rowsPerPageItems,
                  }">
                  <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr @click="viewItem(item)">
                      <td class="text-xs-left">{{ item.empresa }}</td>
                      <td class="text-xs-left">{{ item.nombre }}</td>

                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="deleteItem(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarDetail">
                  <v-icon>list_alt</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Detalle</v-toolbar-title
                  >
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!editMode"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editItem()"
                    v-show="canCreate">
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="model.id != null"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editMode = !editMode"
                    v-show="canUpdate">
                    <v-icon v-if="editMode">cancel</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-text>
                  <v-form :disabled="!editMode">
                    <v-container fluid grid-list-lg>
                      <v-layout wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="model.nombre"
                            label="Nombre"
                            required
                            :disabled="!editMode"
                            v-validate="'required'"
                            data-vv-name="nombre"
                            :error-messages="
                              errors.collect('nombre')
                            "></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            v-model="model.empresaId"
                            :items="empresas"
                            item-text="nombre"
                            item-value="id"
                            label="Empresa"
                            placeholder="Seleccione una empresa"
                            :disabled="!editMode"
                            :v-validate="'required | min_value:1'"
                            data-vv-name="empresa"
                            :error-messages="errors.collect('empresa')"
                            :menu-props="{ minWidth: '400' }">
                          </v-autocomplete>
                        </v-flex>
                        <v-divider></v-divider>
                        <v-flex xs6>
                          <v-autocomplete
                            v-model="model.tipoClasificacionPersonaId"
                            :items="listCalificacionesPersonas"
                            item-text="descripcion"
                            item-value="id"
                            label="Esta Política aplica para Clientes"
                            placeholder="(Indistinto)"
                            :disabled="!editMode"
                            :menu-props="{ minWidth: '400' }">
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-card>
                      <v-card-title> Detalle de la Política </v-card-title>

                      <v-card-text>
                        <v-layout>
                          <v-flex xs6>
                            <v-switch
                              label="Restringir Capital Otorgado"
                              v-model="model.restringeCapital"
                              :disabled="!editMode">
                            </v-switch>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              v-model="model.capitalDesde"
                              label="Capital Desde"
                              :disabled="!editMode || !model.restringeCapital"
                              v-show="model.restringeCapital"
                              v-validate="
                                model.restringeCapital
                                  ? 'required|numeric'
                                  : 'numeric'
                              "
                              data-vv-name="capital desde"
                              :error-messages="
                                errors.collect('capitalDesde')
                              "></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              v-model="model.capitalHasta"
                              label="Capital Hasta"
                              :disabled="!editMode || !model.restringeCapital"
                              v-show="model.restringeCapital"
                              v-validate="
                                model.restringeCapital
                                  ? 'required|numeric'
                                  : 'numeric'
                              "
                              data-vv-name="capital hasta"
                              :error-messages="
                                errors.collect('capital hasta')
                              "></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6>
                            <v-switch
                              label="Restringir Edad Solicitante"
                              v-model="model.restringeEdad"
                              :disabled="!editMode">
                            </v-switch>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              v-model="model.edadDesde"
                              label="Edad Desde"
                              :disabled="!editMode || !model.restringeEdad"
                              v-show="model.restringeEdad"
                              v-validate="
                                model.restringeEdad
                                  ? 'required|numeric'
                                  : 'numeric'
                              "
                              data-vv-name="edad desde"
                              :error-messages="
                                errors.collect('edad desde')
                              "></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              v-model="model.edadHasta"
                              label="Edad Hasta"
                              :disabled="!editMode || !model.restringeEdad"
                              v-show="model.restringeEdad"
                              v-validate="
                                model.restringeEdad
                                  ? 'required|numeric'
                                  : 'numeric'
                              "
                              data-vv-name="edad hasta"
                              :error-messages="
                                errors.collect('edad hasta')
                              "></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs 4>
                            <v-switch
                              label="Establecer Máxima Relación Cuota/Sueldo"
                              v-model="model.restringeRelacionCuotaSueldo"
                              :disabled="!editMode">
                            </v-switch>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              v-model="model.relacionCuotaSueldo"
                              label="Menor a"
                              :disabled="
                                !editMode || !model.restringeRelacionCuotaSueldo
                              "
                              v-show="model.restringeRelacionCuotaSueldo"
                              v-validate="
                                model.restringeRelacionCuotaSueldo
                                  ? 'required|numeric'
                                  : 'numeric'
                              "
                              data-vv-name="relación cuota/sueldo"
                              :error-messages="
                                errors.collect('relación cuota/sueldo')
                              "></v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-switch
                          label="Requiere Datos Bancarios"
                          v-model="model.requiereDatosBancarios"
                          :disabled="!editMode">
                        </v-switch>

                        <v-switch
                          label="Requiere Débito En Cuenta"
                          v-model="model.requiereDebitoEnCuenta"
                          :disabled="!editMode">
                        </v-switch>

                        <v-switch
                          label="Requiere Datos Tarjeta"
                          v-model="model.requiereDatosTarjeta"
                          :disabled="!editMode">
                        </v-switch>

                        <v-switch
                          label="Requiere Débito En Tarjeta"
                          v-model="model.requiereDebitoEnTarjeta"
                          :disabled="!editMode">
                        </v-switch>

                        <v-switch
                          label="Requiere Domicilio Completo"
                          v-model="model.requiereDomicilioCompleto"
                          :disabled="!editMode">
                        </v-switch>

                        <v-switch
                          label="Requiere Datos Celular"
                          v-model="model.requiereDatosCelular"
                          :disabled="!editMode">
                        </v-switch>

                        <!-- <v-switch
                          label="Requiere Domicilio Completo (Sin C.P.)"
                          v-model="model.requiereDomicilioCompletoSinCP"
                          :disabled="!editMode"
                        >
                        </v-switch> -->

                        <v-layout>
                          <v-flex xs 4>
                            <v-switch
                              label="Requiere una Cantidad de Teléfonos Mínima"
                              v-model="model.requiereCantidadTelefonos"
                              :disabled="!editMode">
                            </v-switch>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              v-model="model.cantidadTelefonosMinima"
                              label="Al menos"
                              :disabled="
                                !editMode || !model.requiereCantidadTelefonos
                              "
                              v-show="model.requiereCantidadTelefonos"
                              v-validate="
                                model.requiereCantidadTelefonos
                                  ? 'required|numeric'
                                  : 'numeric'
                              "
                              data-vv-name="cantidad mínima de teléfonos"
                              :error-messages="
                                errors.collect('cantidad mínima de teléfonos')
                              "></v-text-field>
                          </v-flex>
                        </v-layout>

                        <app-lista-doble
                          label="Requisitos"
                          :enabled="editMode"
                          :items="requisitosDisponibles"
                          :selectedItems="model.requisitos"
                          v-model="model.requisitos"
                          :headers="[
                            { text: 'Requisito', value: 'descripcion' },
                            { text: 'Obligatorio', value: 'obligatorio' },
                          ]">
                        </app-lista-doble>
                      </v-card-text>
                    </v-card>

                    <v-divider></v-divider>
                    <template v-if="$store.state.debugModeOn">
                      Debug Info:
                      <p></p>

                      Model: {{ model }}
                      <p></p>
                    </template>
                    <v-divider></v-divider>

                    <v-card-actions bottom>
                      <!-- <v-speed-dial direction="right" >
                             <v-btn slot="activator" color="orange" flat small v-show="editMode">
                                <v-icon color="orange">touch_app</v-icon>                                
                                Mas Acciones
                              </v-btn>
                              <v-tooltip bottom>
                                <v-btn small flat color="green" slot="activator" @click="copiarDomicilio" v-show="editMode">
                                  Copiar Domicilio
                                </v-btn>
                                <v-btn small flat color="green" slot="activator" @click="updateStatus" v-show="editMode">
                                    <v-text v-if="model.status.baja">Habilitar</v-text>
                                    <v-text v-else>Deshabilitar</v-text>
                                </v-btn>
                              </v-tooltip>
                            </v-speed-dial>-->

                      <v-spacer></v-spacer>
                      <v-btn
                        color="success"
                        :disabled="!editMode"
                        @click="saveItem"
                        ><v-icon>save</v-icon>Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de options
      headers: [
        // definición de columnas
        { text: "Empresa", value: "empresa" },
        { text: "Nombre", value: "nombre" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      model: {}, // registro para ver/editar
      empresas: [],
      listCalificacionesPersonas: [],
      requisitosDisponibles: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadCalificacionesPersonas();
    this.loadRequisitos();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    search() {
      this.getItems();
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          "politicasComerciales?nombre=" +
            this.search +
            "&limit=" +
            this.options.itemsPerPage +
            "&page=" +
            this.options.page +
            "&sortby=" +
            this.options.sortBy +
            "&descending=" +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : "false")
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();
      try {
        var result = await http.get("politicasComerciales/" + id);

        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async viewItem(item) {
      if (this.suspend) return;

      this.selectedRow.pop();
      this.selectedRow.push(item);

      await this.getItem(item.id);
      this.editMode = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = { status: {} };
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem(0);
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !(this.model.id === 0);

      await this.$validator.validateAll();

      Vue.$log.debug(this.$validator);

      if (this.errors.items.length > 0) {
        this.alertError(
          "Hay errores en alguno de los campos ingresados. Por favor verifique."
        );
        return;
      }

      if (isUpdate) {
        try {
          var result = await http.put(
            "politicasComerciales",
            JSON.stringify({ politicaComercial: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          Vue.$log.error(error);
          // Error
          this.alertError(error);
        }
      } else {
        try {
          var result = await http.post(
            "politicasComerciales",
            JSON.stringify({ politicaComercial: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async deleteItem(item) {
      if (
        confirm(
          "¿Confirma la eliminación de la política comercial " +
            item.nombre +
            "?"
        )
      ) {
        try {
          var result = await http.delete("politicasComerciales?id=" + item.id);
          this.alertSuccess("El producto ha sido eliminado.");
          this.clearAndReload();
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get("empresas"); // traigo todas
        this.empresas = result.list;

        this.empresas.unshift({ id: 0, nombre: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCalificacionesPersonas() {
      this.loading = true;
      try {
        var result = await http.get("tiposcalificacionpersona"); // traigo todas
        this.listCalificacionesPersonas = result.list;

        this.listCalificacionesPersonas.unshift({
          id: 0,
          descripcion: "(Indistinto)",
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadRequisitos() {
      this.loading = true;
      try {
        var result = await http.get("requisitos"); // traigo todas
        this.requisitosDisponibles = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
